module.exports = __webpack_public_path__ + "static/media/Bouffalant_gaussian2.af70ed6b.png";